import React, { useState } from "react";
import PropTypes from "prop-types";
import { Card, Col, Form, Nav, Row, Tab } from "react-bootstrap";
import Flex from "components/common/Flex";
import styles from "./landing.module.css";

const NavItem = ({ item }) => {
	return (
		<Nav.Item as="li" className={`${styles.TabHeaderLi}`}>
			<Nav.Link className={` mb-0 py-3 cursor-pointer ${styles.TabHeaderStyle}`} eventKey={item?.title?.toLowerCase() || ""}>
				{item.title}
			</Nav.Link>
		</Nav.Item>
	);
};

const TabBox = ({ navItems }) => {
	return (
		<>
			{navItems && (
				<Tab.Container
					id="audience-tab"
					defaultActiveKey={navItems[0]?.title?.toLowerCase() || ""} // safe fallback
				>
					<Card.Header as={Flex} justifyContent="center" alignItems="center" className={`ps-0 py-0 border-bottom ${styles.TabHeaderBackground}`}>
						<Nav as="ul" className={`nav-tabs border-0 flex-nowrap chart-tab tab-active-caret w-100 ${styles.TabHeaderUl}`}>
							{navItems.map((item) => (
								<NavItem item={item} key={item.title} />
							))}
						</Nav>
					</Card.Header>

					<Card.Body>
						<Row className="g-1">
							<Col xxl={12}>
								<Tab.Content>
									{navItems.map((item) => (
										<Tab.Pane unmountOnExit eventKey={item.title.toLowerCase()} key={item.title} dangerouslySetInnerHTML={{ __html: item.description }}></Tab.Pane>
									))}
								</Tab.Content>
							</Col>
						</Row>
					</Card.Body>
				</Tab.Container>
			)}
		</>
	);
};

NavItem.propTypes = {
	item: PropTypes.shape({
		title: PropTypes.string.isRequired,
		description: PropTypes.node,
	}).isRequired,
};

export default TabBox;
